<template>
  <el-container class="fill">
    <el-dialog
      :close-on-press-escape="false"
      :append-to-body="true"
      :closeOnClickModal="false"
      title="网联商务点餐系统服务与协议"
      :visible.sync="payVisible"
      width="800px"
      :showClose="false"
    >
      <div class="text">
        <div>欢迎使用网联商务有限公司（以下简称“网联商务”）提供的网联客点餐管理系统（以下简称“点餐系统”），本服务条款详述您在使用网联商务点餐系统服务所须遵守的条款和条件。</div>
        <p>服务内容：</p>
        <div>
          网联商务为点餐系统提供商，向您提供顾客自助扫描二维码点餐服务，及后台管理（桌位管理、菜品管理、订单管理、桌位状态管理、销售统计）服务。
          您可以自主创建桌位码也可向您的推广员（推广员：为您开通点餐系统的人）申请桌位码，申请的桌位码，免费制作打印（仅限物料）。
        </div>
        <p>服务费用及说明：</p>
        <div>使用点餐系统期间，除一次性付费商户外，月付费、年付费商户使用到期后可通过点餐系统自主续费，点餐系统平台会在后台系统首页自动提醒到期时间（不排除发送手机短信），请在提醒到期后的3天内完成支付。如未续费，网联商务管理后台及管理人员有权将您开通的点餐系统服务进行关闭。关闭后您无权限登录使用点餐系统，顾客不能进行自助点餐。开通点餐系统的商户并且已经支付费用的，在开通超过10天后，终止使用点餐系统，支付的费用不予退还。</div>
        <span>月付费：</span>按月支付费用，会根据您正式使用点餐系统的时间进行计算，每30天向您收取点餐系统使用费用一次。
        <br />
        <span>年付费：</span>按年付费，会根据您正式使用点餐系统时间计算，次年的同一时间会向您收取点餐系统使用费用。
        <br />
        <span>一次性付费：</span>一次性支付使用点餐系统的费用。
        <p>支付渠道：</p>
        <div>
          线下收取：将使用服务费线下交给推广员（推广员：为您开通点餐系统的人）。
          线上收取：将使用服务费通过点餐系统交给网联商务。
        </div>
        <p>商户使用规则</p>
        <div>
          商户单独承担发布内容的责任。商户对系统的使用是根据所有适用于网站服务的地方法律、国家法律和国际法律标准的。
          商户所有的发布内容不得包含下述的任一信息：
          煽动抵抗或违反中华人民共和国宪法、法律或行政法规执行的；煽动颠覆政府或社会主义制度的；煽动分裂国家、破坏祖国统一的；煽动民族仇恨、民族歧视，破坏民族团结的；制造谎言或歪曲事实、散布谣言、破坏社会秩序的；宣扬封建迷信、传播有性挑逗性质的材料、赌博、暴力或凶杀的；宣扬恐怖主义或唆使他人犯罪；公开侮辱他人或歪曲事实诽谤他人的；损害国家机关声誉的；其它违反中华人民共和国宪法、法律和行政法规的内容。
          根据规定，您不得销售非法物品或提供非法服务：血液、体液和人体器官；入室行窃工具；假冒或非法制造的产品；火药、破坏性设备和爆炸性物质；赌博和打赌；任何形式的身份证明文件、个人财务记录以及个人信息；医疗保健，药品和医疗器械；彩票、博彩内容和老虎机；淫秽物品和儿童色情物品；令人反感的内容；卖淫；金字塔系统、多层市场推广以及“快速致富计划”等通过发展上下线的传销方式；盗得的财物；武器和相关物品，例如枪炮、弹夹、弹药、BB枪和铅弹枪、催泪瓦斯，眩晕枪、弹簧刀具和武术兵器；野生动物。
          点餐系统是通过网络发送和收取信息。所以，商户的行为指引是根据国家有关因特网的法规，政策和程序的。商户须承诺不发送任何妨碍社会治安或非法、虚 假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、淫秽色情性等内容的信息内容。另外，商户也不能传输任何教唆他人构成犯罪行为的内容；不能传输助长 国内不利条件和涉及国家安全的内容；不能传输任何不符合当地法规、国家法律和国际法律的内容。若商户的行为不符合以上提到的服务条款，网联商务将作出独立判断立即取消商户点餐系统服务帐号。若您违反有关法律法规及本服务条款的规定了，须自行承担完全的法律责任，并承担因此给本公司造成的损失的法律责任。
        </div>
        <p>服务风险及免责声明</p>
        <div>商户须明白，本服务仅依其当前所呈现的状况提供，本服务涉及到互联网及移动通讯等服务，可能会受到各个环节不稳定因素的影 响。因此服务存在因上述不可抗力、计算机病毒或黑客攻击、系统不稳定、商户所在位置、商户关机、GSM网络、互联网络、通信线路原因等造成的服务中断或不能满足商户要求的风险。开通服务的商户须承担以上风险， 如本公司的系统发生故障影响到本服务的正常运行，本公司承诺在第一时间内与相关单位配合，及时处理进行修复。但商户因此而产生的经济损失，本公司和合作公司不承担责任。</div>
        <p>服务变更、中断或终止及服务条款的修改</p>
        <div>
          服务的所有权和运作权、一切解释权归网联商务有限公司。
          网联商务在必要时修改服务条款，服务条款一旦发生变动，将会在相关页面上公布修改后的服务条款。如果不同意所改动的内容，商户应主动取消此项服务。如果商户继续使用服务，则视为接受服务条款的变动。
          网联商务有限公司保留本服务条款之解释权。
        </div>
      </div>
      <div style class="btnath">
        <el-button style class="golast" type="primary" @click="Agreed">同意协议</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-press-escape="false"
      :append-to-body="true"
      title="修改密码"
      :closeOnClickModal="false"
      :visible.sync="changepass"
      width="400px"
      height="400px"
      :showClose="false"
    >
      <el-form
        :label-position="left"
        :inline="true"
        size="mini"
        label-width="80px"
        :model="formInlinezin"
        class="demo-form-inline"
        :rules="rules"
        ref="formInlinezin"
      >
        <el-row>
          <el-col :span="24" style="margin-left:20px">
            <span style="color:orange;">为保证您的账户安全，请验证您的手机号并修改密码</span>
            <el-form-item label="手机号" prop="mobileNo" style="margin-top:16px">
              <el-input v-model="formInlinezin.mobileNo" clearable maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="smsValidCode">
              <el-input
                v-model="formInlinezin.smsValidCode"
                clearable
                style="width:120px;margin-right:5px;"
              ></el-input>
              <div class="verification" v-show="show">
                <span @click="getCode" style="cursor:pointer;">{{code}}</span>
              </div>
              <div v-show="!show" class="verification" style="background-color:#bfbcbc;color:#fff;">
                <span>{{count}}秒</span>
              </div>
            </el-form-item>
            <el-form-item label="新密码" prop="loginPwd">
              <el-input
                type="password"
                v-model="formInlinezin.loginPwd"
                clearable
                auto-complete="off"
                maxlength="20"
                placeholder="8-20位,支持数字和字母"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="newPwd">
              <el-input
                type="password"
                v-model="formInlinezin.newPwd "
                clearable
                auto-complete="off"
                maxlength="20"
                placeholder="8-20位,支持数字和字母"
              ></el-input>
            </el-form-item>
            <el-form-item style="width:100%;text-align:center">
              <el-button type="primary" @click="submitForm('formInlinezin')">确认</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-aside width="220px">
      <menuList />
    </el-aside>
    <el-container>
      <el-header height="66px">
        <headTop></headTop>
      </el-header>
      <el-main>
        <econtent></econtent>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import menuList from "../components/menu.vue";
import headTop from "../components/headTop.vue";
import econtent from "../components/econtent.vue";
import { mapMutations } from "vuex";
import { wsUrl } from "@/base.js";
import Eve from "@/components/common/emit.js";
export default {
  components: {
    menuList,
    headTop,
    econtent
  },
  created() {
    this.isFirstLogin = localStorage.getItem("isFirstLogin");
    this.formInlinezin.mobileNo = localStorage.getItem("mobileNo");
  },
  mounted() {
    if (
      localStorage.getItem("isPayBefore") &&
      localStorage.getItem("isPayBefore") != 0
    ) {
      this.initWebSocket();
    }
    if (this.isFirstLogin == 1) {
      //首次登陆
      this.changepass = true;
    }
  },

  data() {
    var validatePass = (rule, value, callback) => {
      // let rez = /^[0-9a-zA-Z]{6,20}$/;
      let rez = /^(?![^A-z]+$)(?!\D+$)[A-z\d]{8,20}$/;
      if (!rez.test(value)) {
        return callback(new Error("8-20位,支持数字和字母"));
      }
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.formInlinezin.newPwd !== "") {
          this.$refs.formInlinezin.validateField("newPwd");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formInlinezin.loginPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
      // let rez = /^[0-9a-zA-Z]{6,20}$/;
      let rez = /^(?![^A-z]+$)(?!\D+$)[A-z\d]{8,20}$/;
      if (!rez.test(value)) {
        return callback(new Error("8-20位,支持数字和字母"));
      }
    };
    return {
      show: true,
      count: "",
      timer: null,
      code: "发送验证码",
      time: null,
      websock: "",
      changepass: false,
      payVisible: false,
      isFirstLogin: "",
      left: "left",
      formInlinezin: {
        mobileNo: "",
        smsValidCode: "",
        newPwd: "",
        loginPwd: "",
        loginId: localStorage.getItem("loginUser")
      },
      rules: {
        smsValidCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ],
        mobileNo: [
          {
            required: true,
            message: "请填写手机号",
            trigger: "blur"
          }
        ],
        loginPwd: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          { validator: validatePass, trigger: "blur" },
          {
            min: 8,
            max: 20,
            message: "8-20位,支持数字和字母",
            trigger: "blur"
          }
        ],
        newPwd: [
          {
            required: true,
            message: "请确认密码",
            trigger: "blur"
          },
          { validator: validatePass2, trigger: "blur" },
          {
            min: 8,
            max: 20,
            message: "8-20位,支持数字和字母",
            trigger: "blur"
          }
        ]
      }
    };
  },

  methods: {
    ...mapMutations(["addOrderData"]),
    initWebSocket() {
      //初始化weosocket
      this.websock = new WebSocket(
        wsUrl + localStorage.getItem("platCode_merId")
      );
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.fullscreenLoading = true;
          this.formInlinezin.tokenId = localStorage.getItem("tokenId");
          this.$http
            .post("/w/user/firstLoginOpera", {
              ...this.formInlinezin
            })
            .then(
              data => {
                this.$message.success("修改密码成功");
                this.changepass = false;
                this.$refs["ruleForm2"].resetFields();
                this.fullscreenLoading = false;
              },
              () => {
                this.fullscreenLoading = false;
              }
            );
          this.websock.onopen = this.websocketonopen;
          this.websock.onerror = this.websocketonerror;
          this.websock.onmessage = this.websocketonmessage;
          this.websock.onclose = this.websocketclose;
        }
      });
    },
    websocketonopen() {
      this.$notify({
        title: "成功",
        message: "推送服务连接成功",
        type: "success"
      });
      console.log("WebSocket连接成功");
    },
    websocketonerror(e) {
      //错误
      this.$notify.error({
        title: "错误",
        message: "订单推送提醒功能暂时无法使用，请联系管理员！"
      });
      console.log("WebSocket连接发生错误");
    },
    websocketonmessage(e) {
      //数据接收
      console.log(e);
      this.addOrderData(e.data);
      Eve.$emit("businessStatusList");
      this.$notify.info({
        title: "消息",
        message: "您有新的订单,请及时查看！"
      });
    },

    websocketsend(agentData) {
      //数据发送
      this.websock.send(agentData);
    },

    websocketclose(e) {
      //关闭
      console.log("connection closed (" + e.code + ")");
    },
    beforeDestroy() {
      if (
        localStorage.getItem("isPayBefore") &&
        localStorage.getItem("isPayBefore") != 1
      ) {
        this.websock.close();
      }
    },
    Agreed() {
      this.payVisible = false;
      this.changepass = true;
    },
    getCode() {
      if (this.formInlinezin.mobileNo == "") {
        this.$message.error("请填写手机号");
      } else if (!/^1[0-9]\d{9}$/.test(this.formInlinezin.mobileNo)) {
        this.$message.error("请填写正确的手机号");
        return false;
      } else {
        this.$http
          .post(`/w/sms/sendValidCode`, {
            mobileNo: this.formInlinezin.mobileNo,
            tokenId: localStorage.getItem("tokenId")
          })
          .then(data => {
            this.fullscreenLoading = false;
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  this.code = "重新发送";
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          })
          .catch(error => {
            this.fullscreenLoading = false;
          });
      }
    }
  }
};
</script>

<style scoped>
.verification {
  width: 80px;
  height: 30px;
  background: #409eff;
  font-size: 12px;
  border-radius: 3px;
  line-height: 30px;
  text-align: center;
  color: white;
  display: inline-block;
}
.btnath {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.golast {
  width: 160px;
  height: 40px;
  background: #64caff;
  font-size: 18px;
}
.text {
  height: 400px;
  overflow-x: hidden;
  font-size: 14px;
  letter-spacing: 4px;
  line-height: 1.6;
  font-family: "SimSun";
}
.text p {
  font-size: 18px;
  font-weight: bold;
}
.text div {
  text-indent: 32px;
}
.text span {
  color: red;
}
.fill {
  height: 100%;
}
.el-aside {
  background-color: #43536e;
  color: #333;
  text-align: center;
  line-height: 200px;
}
.el-header {
  padding: 0 30px;
}
.el-main {
  height: 100%;
  padding: 0 30px 10px;
}
</style>


// WEBPACK FOOTER //
// src/view/index.vue